"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerTagDiscount = void 0;
const vue_1 = require("vue");
exports.PlayerTagDiscount = vue_1.default.component('PlayerTagDiscount', {
    props: {
        amount: {
            type: Number,
        },
    },
    methods: {
        getAmount: function () {
            return this.amount * -1;
        },
    },
    template: `
    <div class="player-tag-discount">
      <div class="megacredits-container">
        <div class="megacredits">{{ getAmount() }}</div>
      </div>
    </div>
  `,
});
//# sourceMappingURL=PlayerTagDiscount.js.map